<template>
  <div v-if="showCard === true" class="up-modal" style="right: 0px">
    <b-row class="justify-content-center card-row">
      <b-icon-x-square @click="closeModal" />
      <b-col cols="6" class="p-0 justify-content-center d-flex">
        <b-col 
          cols="12"
          class="employee-card pt-4"
        >
          <h3 class="mt-4">Elija rango de fechas:</h3>
          <b-row class="mt-4 justify-content-center">
            <b-col cols="5">
              <p>Desde:</p>
              <b-input-group size="lg" class="mb-4">
                <b-form-datepicker
                  class="input-basic date-hour-inputs"
                  v-model="startDate"
                  placeholder="Fecha"
                  :start-weekday="1"
                ></b-form-datepicker>
              </b-input-group>
            </b-col>
            <b-col cols="5">
              <p>Hasta:</p>
              <b-input-group size="lg" class="mb-4">
                <b-form-datepicker
                  class="input-basic date-hour-inputs"
                  v-model="endDate"
                  placeholder="Fecha"
                  :start-weekday="1" 
                ></b-form-datepicker>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="mt-4 justify-content-center">
            <b-col cols="10" class="d-flex justify-content-center">
              <b-button @click="saveChanges" class="mt-5 mx-4" variant="success">
                <b-icon-check2-square class="mr-3" />
                Guardar Cambios
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { API_INFO } from "@/constants.js";
import axios from "axios";

export default {
  
  props: {
    showCard: Boolean,
    saveFrom: String
  },
  data() {
    return {
      endDate: new Date().toISOString().split('T')[0],
      startDate: new Date().toISOString().split('T')[0]

    };
  },
  mounted() {
    
  },
  methods: {
    closeModal() {
      this.$emit("close-modal")
    },
    saveChanges() {
      if(this.saveFrom === "table") {
        this.$emit("save-hours-changes",{
          end: this.endDate,
          start: this.startDate
        })
      } else {
        this.$emit("save-team-changes",{
          end: this.endDate,
          start: this.startDate
        })
      }
      this.closeModal()
    },
  },
};
</script>

<style lang="scss" scoped>
.card-row {
  position: relative;
  top: 20vh;
  // max-height: 84vh;
  // overflow: auto; 
}

.employee-card {
  background:rgb(241, 241, 241);
  border-radius: 15px;
  border: 4px solid rgb(151, 159, 173);
  min-height: 270px;
  width: 25vw;
  p {
    font-weight: 700;
    margin-bottom: 10px;
  }
  h3 {
    position: relative;
    right: -8%;
  }
}

.bi-x-square {
  width: 34px;
  height: 34px;
  position: absolute;
  top: -35%;
  right: 45px;
  cursor: pointer;
  background: antiquewhite;
  z-index: 130;
  &:hover {
    background: rgba(255, 117, 98, 0.822);
  }
}
button {
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  position: relative;
  right: -30%;
  top: -20%;
}

</style>
